import React from "react";

function About() {
    return (
        <section className="about">
            About

            <p className="about-text">
                Passionate for software with a simple design, high impact, and attention-to-detail.
            </p>
            <p className="about-text">
                Advocate for using technology to improve lives. Up-to-date with tech news.
            </p>
            <p className="about-text">
                Curious. Dedicated. Team-player.
            </p>
            <p className="about-text">
                Favorite YouTube Channel: <a href="https://www.youtube.com/@CoreDumpped" target="_blank" rel="noreferrer">Core Dumped
                    &#8594;</a>
            </p>
        </section>
    );
}

export default About;
